import { render, staticRenderFns } from "./invalidProducts.vue?vue&type=template&id=7cf8e60c&scoped=true&"
import script from "./invalidProducts.vue?vue&type=script&lang=js&"
export * from "./invalidProducts.vue?vue&type=script&lang=js&"
import style0 from "./invalidProducts.vue?vue&type=style&index=0&id=7cf8e60c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf8e60c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
